// import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
// import ReactFlow, {
//     Controls,
//     Background,
//     useNodesState,
//     useEdgesState,
//     MarkerType
// } from "reactflow";
// import "reactflow/dist/style.css";
// import Layout from "./Layout";
// import { useAuth } from "../contexts/AuthContext";
// import {
//     PiMapTrifoldBold,
//     PiPlusBold,
//     PiArrowLeftBold,
//     PiWarningCircleBold,
//     PiLightningBold
// } from "react-icons/pi";
// import "./MoonshotMapPage.css";
// import MoonshotNode from "../components/MoonshotNode";

// const API_BASE_URL = "http://localhost:5000";

// const MoonshotMapPage = () => {
//     const { currentUser } = useAuth();
//     const [miniShots, setMiniShots] = useState([]);
//     const [selectedMiniShot, setSelectedMiniShot] = useState(null);

//     // Map State
//     const [nodes, setNodes, onNodesChange] = useNodesState([]);
//     const [edges, setEdges, onEdgesChange] = useEdgesState([]);

//     // Memoize Node Types to fix React Flow warning
//     const nodeTypes = useMemo(() => ({
//         start: MoonshotNode,
//         end: MoonshotNode,
//         milestone: MoonshotNode,
//         blocker: MoonshotNode,
//         capability: MoonshotNode,
//         default: MoonshotNode
//     }), []);

//     // UI State
//     const [isLoading, setIsLoading] = useState(false);
//     const [isGenerating, setIsGenerating] = useState(false);
//     const [error, setError] = useState(null);

//     // Load MiniShots on mount
//     useEffect(() => {
//         fetchMiniShots();
//     }, [currentUser]);

//     const fetchMiniShots = async () => {
//         if (!currentUser) return;
//         setIsLoading(true);
//         try {
//             const token = localStorage.getItem('auth_token');
//             const headers = { 'Content-Type': 'application/json' };
//             if (token) {
//                 headers['Authorization'] = `Bearer ${ token }`;
//             }

//             const response = await fetch(`${ API_BASE_URL }/api/minishots`, {
//                 headers: headers,
//                 credentials: 'include'
//             });

//             if (response.status === 401) {
//                 console.error("Auth failed for fetching minishots");
//                 setMiniShots([]);
//                 return;
//             }

//             const data = await response.json();
//             if (data.success) {
//                 setMiniShots(data.data || []);
//                 if (!data.data && data.miniShots) {
//                     setMiniShots(data.miniShots);
//                 }
//             } else {
//                 if (data.miniShots) setMiniShots(data.miniShots);
//             }
//         } catch (err) {
//             console.error("Failed to load projects:", err);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleSelectProject = async (miniShot) => {
//         const pId = miniShot._id || miniShot.id;
//         if (!pId) return;

//         setSelectedMiniShot(miniShot);
//         setIsLoading(true);
//         setError(null);

//         try {
//             const token = localStorage.getItem('auth_token');
//             const headers = {};
//             if (token) {
//                 headers['Authorization'] = `Bearer ${ token }`;
//             }

//             const response = await fetch(`${ API_BASE_URL }/api/moonshot-map/${ pId }`, {
//                 headers: headers,
//                 credentials: 'include'
//             });

//             if (response.ok) {
//                 const data = await response.json();
//                 if (data.moonshotMap && data.moonshotMap.status === 'completed') {
//                     loadMapData(data.moonshotMap.visualMapData);
//                 } else {
//                     generateMap(pId);
//                 }
//             } else if (response.status === 404) {
//                 generateMap(pId);
//             } else {
//                 throw new Error("Failed to load map");
//             }
//         } catch (err) {
//             console.error(err);
//             setError(err.message);
//             setIsLoading(false);
//         }
//     };

//     const generateMap = async (miniShotId) => {
//         setIsGenerating(true);
//         try {
//             const token = localStorage.getItem('auth_token');
//             const headers = { 'Content-Type': 'application/json' };
//             if (token) {
//                 headers['Authorization'] = `Bearer ${ token }`;
//             }

//             const response = await fetch(`${ API_BASE_URL }/api/moonshot-map/generate`, {
//                 method: 'POST',
//                 headers: headers,
//                 credentials: 'include',
//                 body: JSON.stringify({ miniShotId })
//             });

//             const data = await response.json();
//             if (data.success && data.moonshotMap) {
//                 loadMapData(data.moonshotMap.visualMapData);
//             } else {
//                 throw new Error("Failed to generate map");
//             }
//         } catch (err) {
//             setError("Could not generate Moonshot Map. Process timed out or failed.");
//         } finally {
//             setIsGenerating(false);
//             setIsLoading(false);
//         }
//     };

//     const loadMapData = (visualData) => {
//         if (!visualData) return;

//         const mappedNodes = visualData.nodes.map(n => ({
//             id: n.id,
//             type: n.type || 'default', // Pass the specific type to the component
//             position: n.position,
//             data: {
//                 label: n.data.label,
//                 description: n.data.description
//             },
//         }));

//         const mappedEdges = visualData.edges.map(e => ({
//             id: e.id,
//             source: e.source,
//             target: e.target,
//             label: e.label,
//             type: 'default', // Default is Bezier
//             animated: true,
//             style: { stroke: '#94a3b8', strokeWidth: 3 },
//             labelStyle: { fill: '#cbd5e1', fontWeight: 600, fontSize: 12 },
//             markerEnd: {
//                 type: MarkerType.ArrowClosed,
//                 color: '#94a3b8',
//             },
//         }));

//         setNodes(mappedNodes);
//         setEdges(mappedEdges);
//         setIsLoading(false);
//     };

//     const handleBack = () => {
//         setSelectedMiniShot(null);
//         setNodes([]);
//         setEdges([]);
//     };

//     const getReadinessClass = (readiness) => {
//         switch (readiness) {
//             case "Excellent": return "badge-excellent";
//             case "Good": return "badge-good";
//             case "Basic": return "badge-basic";
//             default: return "badge-default";
//         }
//     };

//     return (
//         <Layout>
//             <div className={`moonshot-map-container ${ selectedMiniShot ? 'mode-map' : 'mode-selection' }`}>

//                 {/* SELECTION SCREEN */}
//                 {!selectedMiniShot && (
//                     <div className="project-selection-wrapper">
//                         <div className="simple-header">
//                             <h1>Moonshot Map</h1>
//                             <p>Visualize your strategic path from Current State to Moonshot.</p>
//                         </div>

//                         {isLoading ? (
//                             <div className="loading-state">
//                                 <div className="spinner"></div>
//                             </div>
//                         ) : (
//                             <div className="projects-grid">
//                                 {miniShots.map((ms, index) => (
//                                     <div
//                                         key={ms._id || ms.id || index}
//                                         className="project-card-modern"
//                                         onClick={() => handleSelectProject(ms)}
//                                     >
//                                         <div className="card-top">
//                                             <div className="card-header-row">
//                                                 <span className="card-date">
//                                                     {new Date(ms.createdAt).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
//                                                 </span>
//                                                 <div className={`status-pill ${ getReadinessClass(ms.reportReadiness) }`}>
//                                                     {ms.reportReadiness || "Basic"}
//                                                 </div>
//                                             </div>
//                                             <h3 className="card-title">{ms.title}</h3>
//                                             <p className="card-desc">
//                                                 {ms.description || "No description available."}
//                                             </p>
//                                         </div>
//                                         <div className="card-bottom">
//                                             <div className="meta-stats">
//                                                 <PiMapTrifoldBold /> Interactive Map
//                                             </div>
//                                             <button className="card-action-btn">
//                                                 View Map <PiPlusBold />
//                                             </button>
//                                         </div>
//                                     </div>
//                                 ))}
//                                 {miniShots.length === 0 && (
//                                     <div className="empty-state-full">
//                                         <div className="empty-icon-wrap">
//                                             <PiMapTrifoldBold className="empty-icon" />
//                                         </div>
//                                         <h2>No Projects Yet</h2>
//                                         <p>Create a mini-shot to see your map.</p>
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 )}

//                 {/* MAP SCREEN */}
//                 {selectedMiniShot && (
//                     <div className="map-view-wrapper">
//                         <div className="map-toolbar">
//                             <button className="back-btn" onClick={handleBack}>
//                                 <PiArrowLeftBold /> Back
//                             </button>
//                             <span className="map-title">{selectedMiniShot.title}</span>
//                             {isGenerating && <span className="status-pill badge-good"><PiLightningBold /> Generating...</span>}
//                         </div>

//                         {isLoading || isGenerating ? (
//                             <div className="loading-state" style={{ color: 'white' }}>
//                                 <div className="spinner"></div>
//                                 <p>{isGenerating ? "AI is architecting your map..." : "Loading Map..."}</p>
//                             </div>
//                         ) : error ? (
//                             <div className="error-state" style={{ color: 'white' }}>
//                                 <PiWarningCircleBold size={32} />
//                                 <p>{error}</p>
//                                 <button className="retry-btn" onClick={() => handleSelectProject(selectedMiniShot)}>Retry</button>
//                             </div>
//                         ) : (
//                             <ReactFlow
//                                 nodes={nodes}
//                                 edges={edges}
//                                 onNodesChange={onNodesChange}
//                                 onEdgesChange={onEdgesChange}
//                                 nodeTypes={nodeTypes}
//                                 fitView
//                                 className="map-canvas"
//                             >
//                                 <Background color="#1e293b" gap={20} size={1} />
//                                 <Controls />
//                             </ReactFlow>
//                         )}
//                     </div>
//                 )}

//             </div>
//         </Layout>
//     );
// };

// export default MoonshotMapPage;
import React, { useState, useEffect, useCallback, useMemo } from "react";
import ReactFlow, {
    Controls,
    Background,
    useNodesState,
    useEdgesState,
    MarkerType,
    ReactFlowProvider
} from "reactflow";
import dagre from 'dagre';
import "reactflow/dist/style.css";

import Layout from "./Layout";
import { useAuth } from "../contexts/AuthContext";
import {
    PiArrowLeftBold,
    PiLightningBold,
    PiMagicWandBold,
    PiWarningCircleBold
} from "react-icons/pi";
import "./MoonshotMapPage.css";
import MoonshotNode from "../components/MoonshotNode";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* --- HYBRID LAYOUT ENGINE --- */
// 1. Lays out Main Path (Spine) linearly using Dagre
// 2. Positions "Sticky Notes" (Satellites) relative to their parent nodes
const getLayoutedElements = (nodes, edges, direction = 'LR') => {
    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));
    dagreGraph.setGraph({ rankdir: direction, ranksep: 250, nodesep: 100 });

    const mainTypes = ['start', 'end', 'milestone'];
    const mainNodes = nodes.filter(n => mainTypes.includes(n.type));
    const stickyNodes = nodes.filter(n => !mainTypes.includes(n.type));

    // Map IDs for quick lookup
    const mainNodeIds = new Set(mainNodes.map(n => n.id));

    // Edges purely between main nodes (The Spine)
    const spineEdges = edges.filter(e => mainNodeIds.has(e.source) && mainNodeIds.has(e.target));

    // 1. Layout Main Spine
    mainNodes.forEach((node) => {
        dagreGraph.setNode(node.id, { width: 240, height: 240 });
    });
    spineEdges.forEach((edge) => {
        dagreGraph.setEdge(edge.source, edge.target);
    });

    dagre.layout(dagreGraph);

    // Generate a stable seed from the first node ID to ensure
    // consistent but unique layouts for each project.
    const seedStr = mainNodes[0]?.id || 'default';
    let seed = 0;
    for (let i = 0; i < seedStr.length; i++) seed += seedStr.charCodeAt(i);

    // Derive organic parameters from seed
    const phase = seed * 137; // Arbitrary multiplier for spread
    const freq = 400 + (seed % 200); // Varied width of curves
    const amp = 120 + (seed % 100); // Varied height of curves (120-220px)
    const secondaryAmp = 40 + (seed % 60); // Secondary wave for irregularity

    // Get Main Node Positions
    const layoutedMainNodes = mainNodes.map((node) => {
        const pos = dagreGraph.node(node.id);

        // Complex Organic Wave:
        // Combine Sin + Cos with unique frequency/amplitude per project
        const primaryWave = Math.sin((pos.x + phase) / freq) * amp;
        const secondaryWave = Math.cos((pos.x + phase) / (freq * 0.5)) * secondaryAmp;

        const organicY = primaryWave + secondaryWave;

        return {
            ...node,
            targetPosition: 'left',
            sourcePosition: 'right',
            position: {
                x: pos.x - 120, // Center offset
                y: pos.y - 120 + organicY,
            },
        };
    });

    // 2. Position Sticky Notes (Satellites)
    // We need to know which Main Node each sticky belongs to.
    // We look at the edges to find connections.
    const anchorMap = {}; // stickyId -> mainNodeId

    stickyNodes.forEach(sticky => {
        // Find edge connected to this sticky
        const edge = edges.find(e => e.source === sticky.id || e.target === sticky.id);
        if (edge) {
            // If source is sticky, target is anchor (and vice versa)
            const anchorId = (edge.source === sticky.id) ? edge.target : edge.source;
            anchorMap[sticky.id] = anchorId;
        }
    });

    // Group stickies by Anchor
    const stickiesByAnchor = {};
    Object.keys(anchorMap).forEach(stickyId => {
        const anchorId = anchorMap[stickyId];
        if (!stickiesByAnchor[anchorId]) stickiesByAnchor[anchorId] = [];
        stickiesByAnchor[anchorId].push(stickyId);
    });

    // Assign positions to Stickies
    const layoutedStickyNodes = stickyNodes.map(sticky => {
        const anchorId = anchorMap[sticky.id];
        const anchorNode = layoutedMainNodes.find(n => n.id === anchorId);

        if (!anchorNode) {
            // Fallback if orphan: place at 0,0 or near start?
            return { ...sticky, position: { x: 0, y: 0 } };
        }

        // Determine Slot
        const siblings = stickiesByAnchor[anchorId];
        const index = siblings.indexOf(sticky.id);

        // Slot Logic: Alternate Top / Bottom
        // 0: Top, 1: Bottom, 2: Top-Right, 3: Bottom-Right...
        const isTop = index % 2 === 0;

        // Spread them out if there are many attached to one node
        // 0 (Top) -> shift 0
        // 1 (Bottom) -> shift 0
        // 2 (Top) -> shift +180
        // 3 (Bottom) -> shift +180
        const shiftX = Math.floor(index / 2) * 180;

        // Vertical Offset from Anchor Center
        // isTop ? Go Up : Go Down
        const yDistance = 250;
        const yOffset = isTop ? -yDistance : yDistance;

        return {
            ...sticky,
            position: {
                // Anchor Center X + Shift
                x: (anchorNode.position.x + 120) + shiftX - 80, // 80 is half width of sticky roughly? (160/2)
                // Anchor Center Y + Offset - (Half Sticky Height)
                // We want the edge of the sticky to be some distance away
                y: (anchorNode.position.y + 120) + yOffset - 70,
            },
            // Optimize handles if possible, assuming React Flow auto-detects best handle
        };
    });

    return { nodes: [...layoutedMainNodes, ...layoutedStickyNodes], edges };
};

const MoonshotMapPage = () => {
    const { currentUser } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const [miniShots, setMiniShots] = useState([]);
    const [selectedMiniShot, setSelectedMiniShot] = useState(null);

    // Effect: Sync state with URL param
    useEffect(() => {
        const projectId = searchParams.get("projectId");
        if (projectId && miniShots.length > 0) {
            const project = miniShots.find(ms => (ms._id || ms.id) === projectId);
            if (project && (!selectedMiniShot || (selectedMiniShot._id || selectedMiniShot.id) !== projectId)) {
                handleSelectProject(project, false); // Pass false to avoid recursive URL update
            }
        } else if (!projectId && selectedMiniShot) {
            setSelectedMiniShot(null);
            setNodes([]);
            setEdges([]);
        }
    }, [searchParams, miniShots]);

    // React Flow State
    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);

    const nodeTypes = useMemo(() => ({
        start: MoonshotNode,
        end: MoonshotNode,
        milestone: MoonshotNode,
        blocker: MoonshotNode,
        capability: MoonshotNode,
        risk: MoonshotNode,
        idea: MoonshotNode,
        default: MoonshotNode
    }), []);

    const [isLoading, setIsLoading] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [error, setError] = useState(null);

    // Initial Fetch
    useEffect(() => {
        fetchMiniShots();
    }, [currentUser]);

    const fetchMiniShots = async () => {
        if (!currentUser) return;
        setIsLoading(true);
        try {
            const token = localStorage.getItem('auth_token');
            const headers = token ? { 'Authorization': `Bearer ${ token }` } : {};
            const response = await fetch(`${ API_BASE_URL }/api/minishots`, { headers, credentials: 'include' });
            const data = await response.json();
            if (data.success || data.miniShots) {
                setMiniShots(data.data || data.miniShots || []);
            }
        } catch (err) {
            console.error("Failed to load projects:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelectProject = async (miniShot, updateUrl = true) => {
        const pId = miniShot._id || miniShot.id;
        setSelectedMiniShot(miniShot);

        if (updateUrl) {
            setSearchParams({ projectId: pId });
        }

        setIsLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem('auth_token');
            const headers = token ? { 'Authorization': `Bearer ${ token }` } : {};
            const response = await fetch(`${ API_BASE_URL }/api/moonshot-map/${ pId }`, { headers, credentials: 'include' });

            if (response.ok) {
                const data = await response.json();
                if (data.moonshotMap?.visualMapData) {
                    processAndLoadMap(data.moonshotMap.visualMapData);
                } else {
                    generateMap(pId);
                }
            } else if (response.status === 404) {
                generateMap(pId);
            } else {
                throw new Error("Failed to load map");
            }
        } catch (err) {
            setError(err.message);
            setIsLoading(false);
        }
    };

    const generateMap = async (miniShotId) => {
        setIsGenerating(true);
        try {
            const token = localStorage.getItem('auth_token');
            const headers = { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${ token }` } : {}) };

            const response = await fetch(`${ API_BASE_URL }/api/moonshot-map/generate`, {
                method: 'POST', headers, credentials: 'include',
                body: JSON.stringify({ miniShotId })
            });

            const data = await response.json();
            if (data.success && data.moonshotMap) {
                processAndLoadMap(data.moonshotMap.visualMapData);
            } else {
                throw new Error("Failed to generate map");
            }
        } catch (err) {
            setError("Could not generate Moonshot Map.");
        } finally {
            setIsGenerating(false);
            setIsLoading(false);
        }
    };

    const processAndLoadMap = (visualData) => {
        if (!visualData) return;

        const rawNodes = visualData.nodes.map(n => ({
            id: n.id,
            type: n.type || 'default',
            data: { label: n.data.label, description: n.data.description },
            position: { x: 0, y: 0 }
        }));

        const rawEdges = visualData.edges.map(e => {
            // Distinguish between main path (thick) and sticky notes (thin/curved)
            const isMainPath = e.source.includes('start') || e.target.includes('end') || e.source.includes('milestone');

            return {
                id: e.id,
                source: e.source,
                target: e.target,
                type: 'default', // Bezier curve
                animated: false, // User requested solid lines, usually implies no animation or subtle. Disabling animation for "solid" feel.
                style: {
                    stroke: '#0f172a', // Always black/dark slate
                    strokeWidth: 2,
                    strokeDasharray: 'none' // Always solid
                },
                markerEnd: { type: MarkerType.ArrowClosed, color: '#0f172a' },
            };
        });

        const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(rawNodes, rawEdges, 'LR');

        setNodes(layoutedNodes);
        setEdges(layoutedEdges);
        setIsLoading(false);
    };

    const handleBack = () => {
        setSelectedMiniShot(null);
        setNodes([]);
        setEdges([]);
        setSearchParams({});
    };

    return (
        <Layout>
            <div className={`moonshot-map-container ${ selectedMiniShot ? 'mode-map' : 'mode-selection' }`}>

                {/* --- SELECTION SCREEN (Keep as is, just clean bg) --- */}
                {!selectedMiniShot && (
                    <div className="selection-wrapper">
                        <div className="simple-header">
                            <h1>Moonshot Map</h1>
                            <p>Select a project to unfold your strategic blueprint.</p>
                        </div>
                        {isLoading ? (
                            <div className="loading-state"><div className="spinner"></div></div>
                        ) : (
                            <div className="projects-grid">
                                {miniShots.map((ms, index) => (
                                    <div key={ms._id || index} className="project-card-modern" onClick={() => handleSelectProject(ms)}>
                                        <div className="card-top">
                                            <div className="card-header-row">
                                                <span className="card-date">{new Date(ms.createdAt).toLocaleDateString()}</span>
                                            </div>
                                            <h3 className="card-title">{ms.title}</h3>
                                            <p className="card-desc">{ms.description || "Strategic roadmap."}</p>
                                        </div>
                                        <div className="card-bottom">
                                            <span className="action-link">Open Blueprint <PiMagicWandBold /></span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                {/* --- MAP SCREEN (THE BEAUTIFUL PART) --- */}
                {selectedMiniShot && (
                    <div className="map-view-wrapper">
                        <div className="map-toolbar">
                            <button className="back-btn" onClick={handleBack}><PiArrowLeftBold /> Back to Projects</button>
                            {isGenerating && <span className="generating-badge"><PiLightningBold /> Generating...</span>}
                        </div>

                        {(isLoading || isGenerating || error) && (
                            <div className="map-overlay-status">
                                {error ? (
                                    <div className="status-box error">
                                        <PiWarningCircleBold size={24} />
                                        <p>{error}</p>
                                        <button onClick={() => handleSelectProject(selectedMiniShot)}>Retry</button>
                                    </div>
                                ) : (
                                    <div className="status-box loading">
                                        <div className="spinner"></div>
                                        <p>Architecting your Moonshot...</p>
                                    </div>
                                )}
                            </div>
                        )}

                        <ReactFlowProvider>
                            <ReactFlow
                                nodes={nodes}
                                edges={edges}
                                onNodesChange={onNodesChange}
                                onEdgesChange={onEdgesChange}
                                nodeTypes={nodeTypes}
                                fitView
                                minZoom={0.2}
                                maxZoom={1.5}
                                attributionPosition="bottom-right"
                            >
                                {/* PURE WHITE BACKGROUND */}
                                <Background color="#f1f5f9" gap={40} size={1} />
                                <Controls position="bottom-right" />
                            </ReactFlow>
                        </ReactFlowProvider>


                    </div>
                )}
            </div>
        </Layout>
    );
};

export default MoonshotMapPage;